var _module = require('../../components/module');

_module.factory('Listing', [
    '$log',
    '$http',

    function ListingFactory($log, $http) {
        function Listing(props) {
            if(props) {
                Object.keys(props).reduce(function (obj, key) {
                    obj[key] = props[key];

                    return obj;
                }, this);
            }
        }

        // Static variable to hold the current visible listing to be accessible to all components.
        Listing.selectedListing = null;

        ////////////////////
        // Class Functions
        ////////////////////

        /*
        Gets a listing

        @function get
        @param {String} id
        */
        Listing.get = function getListing(id) {
            return $http.get('/v1/listings/' + id)
                .then(function getListingResponse(response) {
                    return new Listing(response.data.data);
                });
        };

        /*
        Gets a listing and stores it in the selectedListinng static variable

        @function selectListing
        @param {String} id
        */
        Listing.selectListing = function(id) {
            return Listing.get(id)
                .then(function(listing) {
                    Listing.selectedListing = listing;
                    return listing;
                });
        };

        /*
        Set selectedListing static variable to null

        @function deselectListing
        @param {String} id
        */
        Listing.deselectListing = function() {
            Listing.selectedListing = null;
        };

        /*
        Get a listings infographics

        @function getInfographics
        @param {String} id
        */
        Listing.getInfographics = function getInfographics(id) {
            return $http.get('/v1/listings/' + id + '/infographics')
                .then(function getListingResponse(response) {
                    return new Listing(response.data.data);
                });
        };

        /*
        DEPRECATED - 06/16/16 LC
        Use root_folder/libs/simple-cypher decode function instead
        */
        Listing.decodeId = function decodeId(id) {
            $log.warn('WARNING: Listing.decodeId is now deprecated and will be removed in future versions. Switch to simple-cypher decode function instead.');

            return $http.get('/v1/listings/' + id + '/dcd')
                .then(function getListingResponse(response) {
                    return response.data.decoded;
                });
        };


        return Listing;
    }
]);
